import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorAlert, successAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';

const DeleteNotification = ({ notification, onDelete }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.delete(`/Notification/${notification.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                successAlert('Notification deleted successfully.');
                onDelete && onDelete();
                setOpen(false);
            } else {
                errorAlert('Failed to delete notification.');
            }
        } catch (error) {
            console.log(error);
            errorAlert('Failed to delete notification.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button variant="contained" color="error" onClick={() => setOpen(true)} sx={{ width: '100px' }}>
                Delete
            </Button>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">Delete Notification</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        Are you sure you want to delete this notification? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={loading}>
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="error" variant="contained" disabled={loading}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteNotification;
